import Vue from 'vue';

export default {
    activityLog(perPage, page) {
        return Vue.http.get(`activity-log?per_page=${perPage}&page=${page}`);
    }
}